export default "__VITE_ASSET__B5CAt3U0__"